RivalIQ.apps.Discovery.module('data', function (data, App, Backbone, Marionette, $, _) {

    'use strict';

    const NUM_COMPETITORS_TO_SHOW = 2;
    const DEFAULT_INSTAGRAM_HASHTAGS = [
        '#tbt',
        '#fbf',
        '#repost',
        '#latergram',
        '#photooftheday',
        '#instadaily',
        '#nofilter'
    ];
    const NUM_TWITTER_HASHTAGS = 2;
    const NUM_INSTAGRAM_HASHTAGS = 3;

    function getContentSearchTerm(domain, twitterHandle) {
        return (domain + (twitterHandle ? ` -from:${twitterHandle}` : ''));
    }

    data.SearchRecommendationsGenerator = Marionette.Object.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        loadData: function () {
            const me = this;

            const props = me.getProps();

            const now = new Date();
            const timePeriod = RivalIQ.utils.timePeriod.createTimePeriodFromDuration(30, now);

            _.defaults(props, {
                timePeriod: timePeriod
            });

            const baseHashtagMetric = new RivalIQ.models.MetricDefinition({
                concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_HASHTAGS.id,
                dimensions: ['hashtag'],
                limit: 8,
                submetric: RivalIQ.metric.build({}, {
                    concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_HASHTAGS.id,
                    dimensions: ['hashtag', 'companyId']
                }),
                orderBy: 'companies_using',
                sortOrder: 1
            });

            // need to call buildMetric to use submetrics
            const hashtagCompanyCountMetric = RivalIQ.models.MetricDefinition.buildMetric(baseHashtagMetric, _.extend({
                property: 'companies_using'
            }, props));
            const hashtagEngagementRateMetric = RivalIQ.models.MetricDefinition.buildMetric(baseHashtagMetric, _.extend({
                property: 'avg_engagement_rate_per_post'
            }, props));

            const fetches = {
                topHashtags: hashtagCompanyCountMetric.fetch(),
                engagingHashtags: hashtagEngagementRateMetric.fetch()
            };

            if (props.channel === RivalIQ.enums.channels.TWITTER) {
                fetches.companies = RivalIQ.data.companyData.fetchPresences(props);
            }

            const fetchesArr = _.reduce(fetches, function (memo, promise, key) {
                return memo.concat([[key, promise]]);
            }, []);

            return $.when.apply(null, _.map(fetchesArr, _.last))
                .done(function () {
                    const results = _.reduce(arguments, function (memo, metric, idx) {
                        const request = fetchesArr[idx];
                        memo[request[0]] = metric;
                        return memo;
                    }, {});

                    // Save top hashtag
                    let topHashtags = results.topHashtags.getValue({
                        format: false
                    })
                        .map(function (value) {
                            return {
                                name: value[0],
                                count: value[1]
                            };
                        });
                    topHashtags = results.engagingHashtags.getValue({
                        format: false
                    })
                        .map(function (value, i) {
                            const hashtagValues = topHashtags[i];
                            hashtagValues.engagement = value[1];
                            return hashtagValues;
                        });
                    me.topHashtags = _.orderBy(topHashtags, ['count', 'engagement'], ['desc', 'desc']);

                    // Get landscape company information
                    const companyToData = function (model) {
                        return {
                            id: model.id,
                            name: model.get('name'),
                            domain: model.get('domain').replace(/https?:\/\/(www\.)?/, '').replace(/\/$/, ''),
                            twitterHandle: _.get(model.getPrimaryRecord(RivalIQ.enums.sources.TWITTER), ['presence', 'handle'])
                        };
                    };

                    // Save focus company information
                    if (results.companies) {
                        const companyData = results.companies.get(props.focusCompanyId);

                        if (companyData) {
                            me.focusCompany = companyToData(companyData);
                        }

                        // Save top mentioned competitor
                        if (results.mentions) {
                            let topMentionedCompanies = results.mentions.getValue({
                                format: false
                            });
                            topMentionedCompanies = _.orderBy(topMentionedCompanies, [_.last], ['desc']);


                            me.topMentionedCompetitors = _(topMentionedCompanies)
                                .filter(function (mentioner) {
                                    const companyId = mentioner[0];
                                    return companyId !== props.focusCompanyId;
                                })
                                .take(NUM_COMPETITORS_TO_SHOW)
                                .map(function (topMentionedCompetitor) {
                                    const competitorData = results.companies.get(topMentionedCompetitor[0]);
                                    return competitorData && companyToData(competitorData);
                                })
                                .compact()
                                .value();
                        }

                    }
                });
        },

        getRecommendations: function () {
            const me = this;

            const channel = me.getProp('channel');

            const recommendations = [];
            const numHashtagsToShow = (channel === RivalIQ.enums.channels.TWITTER ? NUM_TWITTER_HASHTAGS : NUM_INSTAGRAM_HASHTAGS);

            if (!_.isEmpty(me.topHashtags)) {

                _.forEach(_.take(me.topHashtags, numHashtagsToShow), function (topHashtag) {
                    const hashtag = `#${topHashtag.name}`;
                    recommendations.push({
                        type: 'top-hashtag', // TODO: add these constants to data
                        value: hashtag,
                        searchTerm: hashtag,
                        channel: channel
                    });
                });
            }

            if (me.focusCompany) {

                recommendations.push({
                    type: 'my-content',
                    searchTerm: getContentSearchTerm(me.focusCompany.domain, me.focusCompany.twitterHandle),
                    channel: channel
                });
            }

            // It's possible that there is no other top mentioned if only one company in landscape
            _.forEach(me.topMentionedCompetitors, function (topMentionedCompetitor) {
                recommendations.push({
                    type: 'top-mentioned',
                    value: topMentionedCompetitor.name,
                    searchTerm: getContentSearchTerm(topMentionedCompetitor.domain, topMentionedCompetitor.twitterHandle),
                    channel: channel
                });
            });

            if (recommendations.length === 0 && channel === RivalIQ.enums.channels.INSTAGRAM) {
                _.each(_.sampleSize(DEFAULT_INSTAGRAM_HASHTAGS, numHashtagsToShow), function (hashtag) {
                    recommendations.push({
                        type: 'top-hashtag',
                        value: hashtag,
                        searchTerm: hashtag,
                        channel: channel
                    });
                });
            }

            return new Backbone.Collection(recommendations);
        }
    });
});
